import React, { useRef, useState } from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Stack from "@mui/joy/Stack";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import "react-international-phone/style.css";
import { Button } from "primereact/button";
import { add, update } from "../../service/equipmentTypesService";
import { Grid } from "@mui/material";
import IntervalDropdown from "../../components/IntervalDropdown";
import MultiDropdownApi from "../../components/MultiDropdownApi";
import { TabPanel, TabView } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { vehicleTypeAdd, vehicleTypeUpdate } from "../../service/vehicleTypesService";
import { FREQUENCIES } from "../forms-allocation/constants";
import { Dropdown } from "primereact/dropdown";
import DropdownApi from "../../components/DropdownApi";
import { Input, MultiSelect, Select } from "../../components/Shared/Forms";
import useApiService from "../../hooks/useApiService";
export default function VehicleTypeAdd(modalProps: any) {
  const details = modalProps?.details;

  const [name, setName] = useState(details?.name || "");
  const [nameError, setNameError] = useState(false);

  const [safeVehicleChecklist, setSafeVehicleChecklist] = useState(
    details?.vehicle_safe_checklist || [""]
  );

  const [riskVehicleChecklist, setRiskVehicleChecklist] = useState(
    details?.vehicle_risk_checklist || [""]
  );

  const [appointment, setAppointment] = useState(details?.appointment || "");

  const [hazard, setHazard] = useState(details?.hazard || "");

  const [frequency, setFrequency] = useState(details?.frequency || 1);

  const [safeWorkMethod, setSafeWorkMethod] = useState(details?.safe_work_method || "");
  const [relevantAppointment, setRelevantAppointment] = useState(
    details?.relevant_appointment || []
  );


  const { loading: loadingRiskHazards, data: riskHazardData } = useApiService<any[]>({
    url: "risk-hazard",
    method: "GET",
    apiName: "core",
  });

  const { loading: appointmentsLoading, data: appointmentsData } = useApiService<any[]>({
    url: "appointments",
    method: "GET",
    apiName: "core",
  });

  const { loading: safeWorkMethodLoading, data: safeWorkMethodData } = useApiService<any[]>({
    url: "safe-work-method",
    method: "GET",
    apiName: "core",
  });

  async function addIndustry() {
    setNameError(!name || name === "");
    if (!name || name === "") {
      modalProps.toast.current.show({
        severity: "warn",
        summary: "Please enter all required fields",
        life: 3000,
      });
      return;
    }
    const updateDetails = {
      name,
      vehicle_safe_checklist: safeVehicleChecklist,
      vehicle_risk_checklist: riskVehicleChecklist,
      appointment: appointment,
      frequency,
      hazard,
      safe_work_method: safeWorkMethod,
      relevant_appointment: relevantAppointment,
    };
    if (modalProps.id) {
      vehicleTypeUpdate(modalProps.id, updateDetails).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Vehicle Type Updated Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    } else {
      vehicleTypeAdd(updateDetails).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Vehicle Type Created Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    }
  }

  return (
    <React.Fragment>
      <TabView>
        <TabPanel header="Details">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Input
                label={"Vehicle Type"}
                required={true}
                value={name}
                placeholder={"Vehicle Type"}
                onChange={e => setName(e.target.value)}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <MultiSelect
              options={
                riskHazardData?.map(item => ({
                  value: item.id,
                  label: item.name,
                })) ?? []
              }
              label={"Hazard"}
              value={hazard}
              onChange={e => setHazard(e.value)}
              onSelectAll={e => {
                setHazard(e);
              }}
              loading={loadingRiskHazards}
            />
          </Grid>
          <Grid item xs={6}>
            <Input
              value={frequency}
              onChange={(e: any) => setFrequency(e.target.value)}
              type={"number"}
              label={"Checklist Frequency (in days)"}
            />
          </Grid>
          <Grid item xs={6}>
            <Select
              options={
                appointmentsData?.map(item => ({
                  value: item.id,
                  label: item.name,
                })) ?? []
              }
              filter={true}
              label={"Checklist Appointment"}
              value={appointment}
              onChange={e => setAppointment(e.value)}
              showClear={true}
              loading={appointmentsLoading}
            />
          </Grid>
          <Grid item xs={12}>
            <MultiDropdownApi
              apiPath="appointments"
              optionLabel="name"
              optionValue="id"
              label="Relevant Appointments"
              selectedData={relevantAppointment}
              setSelectedData={setRelevantAppointment}
            />
          </Grid>
          <Grid item xs={12}>
            <Select
              options={
                safeWorkMethodData?.map(item => ({
                  value: item.id,
                  label: item.name,
                })) ?? []
              }
              filter={true}
              label={"Safe Work Method"}
              value={safeWorkMethod}
              onChange={e => setSafeWorkMethod(e.value)}
              loading={safeWorkMethodLoading}
              showClear={true}
            />
          </Grid>
        </TabPanel>
        <TabPanel header="Checklist">
          <TabView>
            <TabPanel header="Safe">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
                    <FormLabel>Questions</FormLabel>
                  </FormControl>
                </Grid>
                {safeVehicleChecklist.map((checklist: any, index: number) => {
                  return (
                    <Grid item xs={12} key={index}>
                      <IconField>
                        <InputIcon
                          className="pi pi-trash"
                          style={{ color: "#eb445a" }}
                          onClick={() => {
                            const updatedChecklist = [...safeVehicleChecklist];
                            updatedChecklist.splice(index, 1);
                            setSafeVehicleChecklist(updatedChecklist);
                          }}
                        >
                          {" "}
                        </InputIcon>
                        <InputText
                          value={checklist}
                          onChange={e => {
                            const updatedChecklist = [...safeVehicleChecklist];
                            updatedChecklist[index] = e.target.value;
                            setSafeVehicleChecklist(updatedChecklist);
                          }}
                          style={{ width: "100%" }}
                          type="text"
                          className="p-inputtext-sm PrimeSmallInput"
                          placeholder={`Please enter question ${index + 1}`}
                        />
                      </IconField>
                    </Grid>
                  );
                })}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "100%",
                    marginTop: "1rem",
                  }}
                >
                  <Button
                    type="button"
                    icon="pi pi-plus"
                    label="Add"
                    className="p-button-outlined"
                    size="small"
                    onClick={() => {
                      const updatedChecklist = [...safeVehicleChecklist];
                      updatedChecklist.push("");
                      setSafeVehicleChecklist(updatedChecklist);
                    }}
                  />
                </div>
              </Grid>
            </TabPanel>
            <TabPanel header="At Risk">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl sx={{ display: { sm: "flex-column", md: "flex-row" } }}>
                    <FormLabel>Questions</FormLabel>
                  </FormControl>
                </Grid>
                {riskVehicleChecklist.map((checklist: any, index: number) => {
                  return (
                    <Grid item xs={12} key={index}>
                      <IconField>
                        <InputIcon
                          className="pi pi-trash"
                          style={{ color: "#eb445a" }}
                          onClick={() => {
                            const updatedChecklist = [...riskVehicleChecklist];
                            updatedChecklist.splice(index, 1);
                            setRiskVehicleChecklist(updatedChecklist);
                          }}
                        >
                          {" "}
                        </InputIcon>
                        <InputText
                          value={checklist}
                          onChange={e => {
                            const updatedChecklist = [...riskVehicleChecklist];
                            updatedChecklist[index] = e.target.value;
                            setRiskVehicleChecklist(updatedChecklist);
                          }}
                          style={{ width: "100%" }}
                          type="text"
                          className="p-inputtext-sm PrimeSmallInput"
                          placeholder={`Please enter question ${index + 1}`}
                        />
                      </IconField>
                    </Grid>
                  );
                })}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "100%",
                    marginTop: "1rem",
                  }}
                >
                  <Button
                    type="button"
                    icon="pi pi-plus"
                    label="Add"
                    className="p-button-outlined"
                    size="small"
                    onClick={() => {
                      const updatedChecklist = [...riskVehicleChecklist];
                      updatedChecklist.push("");
                      setRiskVehicleChecklist(updatedChecklist);
                    }}
                  />
                </div>
              </Grid>
            </TabPanel>
          </TabView>
        </TabPanel>
      </TabView>
      <br />
      <br />
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: "flex-end", pt: 2 }}>
          <Button
            name="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => addIndustry()}
          />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
